import { formatRoute as namedRoutesFormatRoute } from "react-router-named-routes"
import Fuse from "fuse.js"

// This function will take in the route "/:entityType(facility|department)/:entityId"
// and treat it as "/:entityType/:entityId" when sending it to formatRoute, since
// react-router-named-routes doesn't know how to support custom match parameters.
export const formatRoute = (route, params) => {
  const strippedRoute = route.replace(/\([^)]*\)/g, "") // remove custom match params
  return namedRoutesFormatRoute(strippedRoute, params)
}

// Takes in epoch milliseconds, returns milliseconds or null
export const timeBetween = (start, end) => {
  if (start && end) {
    return end - start
  } else {
    return null
  }
}

export const fuseConfig = {
  keys: ["name"],
  shouldSort: true,
  threshold: 0.499999,
  includeScore: true,
  includeMatches: false,
}

export const getAutosuggestOptions = (inputValue, allOptions) => {
  const inputLength = inputValue.length

  const fuse = new Fuse(allOptions, fuseConfig)
  const filteredNames = fuse.search(inputValue).map(result => result.item.name)

  /* istanbul ignore next */
  return inputLength === 0 ? [] : filteredNames
}

export const getSelectDropdownOptions = (inputValue, allOptions) => {
  if (inputValue.length <= 0) {
    return allOptions.map(item => ({ value: item.id, label: item.name }))
  }

  const fuse = new Fuse(allOptions, fuseConfig)
  return fuse
    .search(inputValue)
    .map(result => ({ value: result.item.id, label: result.item.name }))
}

export const countResults = results => {
  const resultCounts = {}

  results.forEach(result => {
    resultCounts[result]
      ? (resultCounts[result] += 1)
      : (resultCounts[result] = 1)
  })

  return resultCounts
}
